import React, { Component } from "react";
import {Row,Col,Button,Modal} from "react-bootstrap";

class ChemistInvoiceStatusChange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  Submit = () => {
    let value = this.props.ChemistInvoiceActiveDtls;
    this.props.ChemistInvoiceStatusChange(value);
    this.props.handleClose();
    this.props.resetPage();
  };

  render() {
    const data =
      this.props.ChemistInvoiceActiveDtls && this.props.ChemistInvoiceActiveDtls.item
        ? this.props.ChemistInvoiceActiveDtls && this.props.ChemistInvoiceActiveDtls.item
        : null;

    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="md"
            backdrop="static"
            centered={true}
            // className="modal-backdrop fade show"
          >

            {data !== null && data.status === "paid" ? (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Change the invoice status to "Cancelled"?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Change the invoice status to "Paid"?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "30px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            )}
  
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistInvoiceStatusChange;
